import { oz } from '@weft/utils';
import { DiscountTypeSchema } from '../discount-type-schema';

export const TierDiscountConfigurationSchema = oz.object({
  amount: oz.number().nonnegative(),
  type: DiscountTypeSchema,
}).openapi('TierDiscountConfiguration');

export type TierDiscountConfiguration = oz.infer<typeof TierDiscountConfigurationSchema>;